import AxiosConfig from '../../../config/AxiosConfig';

const useStartDeploy = () => {
  const setStartDeploy = async (update) => {
    try {
      const res = AxiosConfig.create('put', `/system/start/`)
        .call(update)
        .getResponseData();
      return res;
    } catch (err) {
      console.error('Failed to start deploy:', err);
      throw new Error(`System deployment failed to start: ${err.message}`);
    }
  };
  return { setStartDeploy };
};

export default useStartDeploy;
